import { Injectable } from '@angular/core';
import { PasswordPolicy } from 'src/app/model/passwordPolicy.modals';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PasswordPolicyService {
  serverUrl: String = environment.serverUrl;
  constructor(private httpClient: HttpClient) { }
  getPasswordPolicyDetails(appId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.get(this.serverUrl + 'password-policy/policyDetails/' + appId,httpOptions);
  }
  savePasswordPolicy(modal: PasswordPolicy) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    var result=this.httpClient.post(this.serverUrl + 'password-policy/savePolicyDetails', modal, httpOptions);
    return result;
  }

  updatePasswordPolicy(modal: PasswordPolicy) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.httpClient.post(this.serverUrl + 'password-policy/updatePolicyDetails', modal, httpOptions);
  }

}
